import type {
  DiagnosisDetail,
  DiagnosisListItem,
  DiagnosisUsage,
} from '@/types/productOptimization';

/**
 * Figma 486:7754 (상품 최적화 진단_상세화면_예시) 기반 샘플 진단.
 * 리스트가 비었을 때 "예시 카드" 로 표시되고, 클릭 시 상세에도 재사용됨.
 * 모든 샘플의 id 는 음수 (음수 = mock 식별, DiagnosisDetailPanel 에서 API 호출 스킵).
 */
export const mockDiagnosis: DiagnosisDetail = {
  id: -1,
  goodsUrl: 'https://smartstore.naver.com/example/products/sample',
  goodsNo: 'SAMPLE',
  storeName: '예시 스토어',
  goodsName: '무선청소소기 파워강력 블랙/화이트 무료배송  ★특가★',
  goodsImageUrl: '/images/sample-diagnosis-product.png',
  salePrice: 189900,
  originalPrice: 249000,
  deliveryFee: 3000,
  wishCount: 97,
  reviewCount: 832,
  rating: 4.8,
  totalScore: 56,
  status: 'Completed',
  diagnosisDate: '2025-04-03T00:00:00',
  basicInfoItems: [
    {
      itemName: '상품명',
      itemCode: 'name_duplicate',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message: '상품명에 중복된 키워드가 없습니다.',
      currentValue: '무선청소기 파워강력 블랙/화이트 무료배송 ★특가★',
    },
    {
      itemName: '상품명',
      itemCode: 'name_colors',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message: '여러 색상(블랙,화이트)이 나열되어 있습니다. 대표 색상 1개만 표기하세요.',
    },
    {
      itemName: '상품명',
      itemCode: 'name_promo_shipping',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message: '‘무료배송’ 등 배송/가격 혜택 문구가 포함되어 있습니다. 해당 문구를 제거하세요.',
    },
    {
      itemName: '상품명',
      itemCode: 'name_promo_expr',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message:
        '‘파워강력’ 홍보성 표현이 포함되어 있습니다. 객관적인 상품 정보 중심으로 수정하세요.',
    },
    {
      itemName: '상품명',
      itemCode: 'name_special_char',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message: '‘★’ 특수문자가 포함되어 있습니다. 특수문자를 모두 제거하세요.',
    },
    {
      itemName: '상품명',
      itemCode: 'name_length',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message: '상품명이 32자로 적정 길이입니다.',
    },
    {
      itemName: '상품명',
      itemCode: 'name_forbidden',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message: '금지 수식어 ‘특가’가 포함되어 있습니다. 해당 단어를 제거하세요.',
    },
    {
      itemName: '카테고리',
      itemCode: 'category_fit',
      grade: '적합',
      score: 6,
      maxScore: 6,
      message: '카테고리 적합도가 100%로 노출에 유리해요.',
      currentValue: '디지털/가전 > 청소기 > 무선청소기 > 핸디스틱청소기',
    },
    {
      itemName: '등록일',
      itemCode: 'registered_date',
      grade: '적합',
      score: 6,
      maxScore: 6,
      message: '등록된지 6개월 이하 상품으로 노출에 유리해요',
      currentValue: '2025.04.28',
    },
  ],
  productDetailItems: [
    {
      itemName: '판매태그',
      itemCode: 'sale_tag',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message: '판매태그가 7개 등록되어 있습니다.',
    },
    {
      itemName: '상품 정보',
      itemCode: 'product_info',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message: '모델명 정보가 입력 되어있지 않아요.',
    },
    {
      itemName: '상품 등록일',
      itemCode: 'detail_registered_date',
      grade: '나쁨',
      score: 0,
      maxScore: 0,
      message: '등록된지 6개월 이상된 상품으로 노출에 불리해요.',
    },
    {
      itemName: '할인',
      itemCode: 'discount',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message: '할인율(32%)이 설정되어 있습니다.',
    },
  ],
  salesManagementItems: [
    {
      itemName: '리뷰',
      itemCode: 'reviews',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message:
        '최근 2건의 리뷰에 답변을 하지 않았어요. 답변은 상품의 신뢰와 재구매 비율을 높여줘요.',
    },
    {
      itemName: 'Q&A 응답',
      itemCode: 'qna',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message:
        '100% 응답률이에요. 1일 이내 응답률을 90%이상 유지하면 굿서비스 스토어로 선정될 수 있어요.',
    },
    {
      itemName: '평균 배송일',
      itemCode: 'avg_shipping_days',
      grade: '적합',
      score: 0,
      maxScore: 0,
      message:
        '1.43일이에요. 평균 배송일을 2일 이내로 유지하면 굿서비스 스토어로 선정될 수 있어요.',
    },
  ],
};

export const mockDiagnoses: DiagnosisListItem[] = [mockDiagnosis];

export const mockUsage: DiagnosisUsage = {
  usedCount: 1,
  maxCount: 20,
  isMembership: true,
};
